/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/SpineModel.glb 
Author: Ruth Lilly Medical Library, IU School of Medicine (https://sketchfab.com/iusmlib)
License: CC-BY-NC-SA-4.0 (http://creativecommons.org/licenses/by-nc-sa/4.0/)
Source: https://sketchfab.com/3d-models/spine-39ad9be7118d402ca7266fab01b75fed
Title: Spine
*/

import React from "react";
import { useGLTF } from "@react-three/drei";
useGLTF.preload("/SpineModel.glb");

export function SpineModel(props) {
  const { nodes, materials } = useGLTF("/SpineModel.glb");
  return (
    <group {...props} dispose={null} scale={.009}>
      <mesh
        geometry={nodes.mmGroup0_lambert2_0.geometry}
        material={materials.lambert2}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup2_lambert6_0.geometry}
        material={materials.lambert6}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup4_lambert4_0.geometry}
        material={materials.lambert4}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup6_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup8_lambert6_0.geometry}
        material={materials.lambert6}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup10_lambert4_0.geometry}
        material={materials.lambert4}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup12_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup14_lambert6_0.geometry}
        material={materials.lambert6}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup16_lambert4_0.geometry}
        material={materials.lambert4}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup18_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup20_lambert6_0.geometry}
        material={materials.lambert6}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup22_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup24_lambert6_0.geometry}
        material={materials.lambert6}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup26_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup28_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup30_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup32_lambert6_0.geometry}
        material={materials.lambert6}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup34_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup36_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup38_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup40_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup42_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup44_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup46_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup48_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup50_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup52_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup54_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup56_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup58_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup60_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup62_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup64_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup66_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup68_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup70_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup72_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup74_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup76_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup78_lambert3_0.geometry}
        material={materials.lambert3}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup80_lambert6_0.geometry}
        material={materials.lambert6}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup82_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup84_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup86_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup88_lambert4_0.geometry}
        material={materials.lambert4}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup90_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup92_lambert4_0.geometry}
        material={materials.lambert4}
        position={[0, 0, -855.084]}
      />
      <mesh
        geometry={nodes.mmGroup94_lambert5_0.geometry}
        material={materials.lambert5}
        position={[0, 0, -855.084]}
      />
    </group>
  );
}

useGLTF.preload("/SpineModel.glb");
